// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file requests/v1/customization_change_request.proto (package requests.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file requests/v1/customization_change_request.proto.
 */
export const file_requests_v1_customization_change_request: GenFile =
    /*@__PURE__*/
    fileDesc(
        'Ci5yZXF1ZXN0cy92MS9jdXN0b21pemF0aW9uX2NoYW5nZV9yZXF1ZXN0LnByb3RvEgtyZXF1ZXN0cy52MSJYChpDdXN0b21pemF0aW9uQ2hhbmdlUmVxdWVzdBIOCgZhY3RpdmUYASABKAgSGQoMZm9yY2VfY3JlYXRlGAIgASgISACIAQFCDwoNX2ZvcmNlX2NyZWF0ZUKFAQoPY29tLnJlcXVlc3RzLnYxQh9DdXN0b21pemF0aW9uQ2hhbmdlUmVxdWVzdFByb3RvUAFaBC4vcGKiAgNSWFiqAgtSZXF1ZXN0cy5WMcoCC1JlcXVlc3RzXFYx4gIXUmVxdWVzdHNcVjFcR1BCTWV0YWRhdGHqAgxSZXF1ZXN0czo6VjFiBnByb3RvMw'
    );

/**
 * @generated from message requests.v1.CustomizationChangeRequest
 */
export type CustomizationChangeRequest = Message<'requests.v1.CustomizationChangeRequest'> & {
    /**
     * @generated from field: bool active = 1;
     */
    active: boolean;

    /**
     * @generated from field: optional bool force_create = 2;
     */
    forceCreate?: boolean | undefined;
};

/**
 * Describes the message requests.v1.CustomizationChangeRequest.
 * Use `create(CustomizationChangeRequestSchema)` to create a new message.
 */
export const CustomizationChangeRequestSchema: GenMessage<CustomizationChangeRequest> =
    /*@__PURE__*/
    messageDesc(file_requests_v1_customization_change_request, 0);
